import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { PlumaPanel as PlumaPanelCss } from '@customerio/pluma-components/css/components';

/** The strip at the foot of a list's panel. The panel does not clip, so the strip rounds its own corners. */
export const strip = style(
  {
    backgroundColor: themeVars.color['scope-accent-subtle-bg'],
    borderTop: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-accent-subtle-border']}`,
    borderBottomLeftRadius: `calc(${PlumaPanelCss.resolvedVars.panelBorderRadius} - ${PlumaPanelCss.resolvedVars.panelBorderWidth})`,
    borderBottomRightRadius: `calc(${PlumaPanelCss.resolvedVars.panelBorderRadius} - ${PlumaPanelCss.resolvedVars.panelBorderWidth})`,
    padding: `${themeVars.space['150']} ${themeVars.space['200']}`,
  },
  'older-history-notice-strip',
);
